export const ThemeConfig = {

	theme_name: 'SIR',
	current_year: 2024,
	home_link: '/dashboard',

	layout: {
		sidebar: {
			always_drawer_mode: false,
		},
	},

	colors: {
		primary: '#2949EF',
		secondary: '#6c757d',
		success: '#0C8B3E',
		info: '#00bcd4',
		warning: '#fd7e14',
		danger: '#FE4D2E',
		light: '#dee2e6',
		purple: '#6f42c1',
		indigo: '#6610f2',
		pink: '#e83e8c',
		yellow: '#FDA424',
		teal: '#20c997',
	},

}
